import get from 'lodash/get';
import React from 'react';

export function replaceInterpolatedVariables<T extends object>(data: object, copy: T): T {
  // This regex captures variables within {{ }}
  const regex = /{{\s*([\w.-]+)\s*}}/gi;

  return Object.entries(copy).reduce((acc, [key, value]) => {
    // We don't expect to have falsy values, but just in case,
    // we can leave them untouched.
    // Leave React components as they are if their are any present in the variant.
    if (!value || React.isValidElement(value)) {
      return acc;
    }

    // Copy can have nested objects, and we want to replace
    // all strings, even deep in the object.
    if (typeof value === 'object') {
      return {
        ...acc,
        [key]: replaceInterpolatedVariables(data, value),
      };
    }

    return {
      ...acc,
      [key]: value.toString().replace(regex, function replacer(_match: string, capturedVariableName: string) {
        return get(data, capturedVariableName) || '';
      }),
    };
  }, copy);
}
